import React from "react"
import { Box } from "@mallardbay/lib-react-components"

import ResponsiveBlock from "~components/shared/responsive-block"
import PageNotFoundImg from "~images/404.svg"
import { useFeaturedListings } from "~utils/use-listings"
import COPY from "~config/copy-constants"
import ListingsCollection from "~components/shared/collections/listings-collection"
import AspectRatio from "~components/shared/todo-lib-react-components/aspect-ratio"

export default function PageNotFound() {
    const styles = useStyles()
    const { listings, isLoading } = useFeaturedListings()
    const hasFeaturedListings = listings.length > 0

    return (
        <ResponsiveBlock>
            <Box style={styles.root}>
                <AspectRatio ratio={3 / 2} style={styles.imageBox}>
                    <img
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                        src={PageNotFoundImg}
                    />
                </AspectRatio>
                <Box style={styles.text}>
                    <Box style={styles.header}>
                        {COPY.PAGE_NOT_FOUND_ERRORS.PAGE_DOES_NOT_EXIST}
                    </Box>
                    {hasFeaturedListings && (
                        <Box style={styles.subTitle}>
                            {COPY.PAGE_NOT_FOUND_ERRORS.TRY_FEATURED_LISTING}
                        </Box>
                    )}
                </Box>
                {hasFeaturedListings && (
                    <Box style={styles.carousel}>
                        <ListingsCollection
                            label={COPY.FEATURED_LISTINGS}
                            listings={listings}
                            isLoading={isLoading}
                        />
                    </Box>
                )}
            </Box>
        </ResponsiveBlock>
    )
}

function useStyles() {
    return {
        root: {
            marginTop: "24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        text: {
            width: { base: "100%", md: "80%" },
            textAlign: "center",
            paddingTop: "48px",
        },
        header: {
            fontSize: { base: "25px", md: "30px" },
        },
        subTitle: {
            fontSize: { base: "16px", md: "20px" },
            marginTop: "16px",
        },
        imageBox: {
            width: "100%",
            maxWidth: "400px",
            marginTop: "24px",
        },
        carousel: {
            marginTop: "24px",
            marginBottom: "64px",
            width: "100%",
        },
    }
}
